import Audit from './AuditoriaService'

export const AuditService = Audit
